import moment from "moment";
import {nextWorkingDay} from "./MakeReservation/util";

export const validateStartEndValues = (startDate: moment.Moment | null, endDate: moment.Moment | null, creatingRes?: boolean) => {
    // round up minutes in start or end date-time to interval of 15 if incorrect interval found
    let newStartDate = startDate;
    let newEndDate = endDate;
    if(newStartDate && newEndDate) {
        newStartDate = moment(startDate)
        if(newStartDate.minutes()%15 !== 0) {
            newStartDate = moment(newStartDate).add((15 - newStartDate.minutes()%15), 'minutes').seconds(0).milliseconds(0);
        }

        if(newEndDate) {
            // check that 2 hour duration still applied with rounding up (if any was done)
            newEndDate = moment(endDate);
            if (newEndDate.diff(newStartDate, 'm') < 120) {
                newEndDate = moment(newStartDate).add(2, "hours").seconds(0).milliseconds(0);
            } else if (newEndDate.minutes()%15 !== 0) {
                newEndDate = moment(newEndDate).add((15 - newEndDate.minutes()%15), 'minutes').seconds(0).milliseconds(0);
            }
        }
    } else if (!creatingRes) { // do not do this if doing check for creating res - rather send null than reset dates
        // if valid dates not provided, reset date sto default next working day dates
        const defaultDate = nextWorkingDay().hour(8).minute(60).seconds(0).milliseconds(0);
        newStartDate = defaultDate.clone();
        newEndDate = defaultDate.clone().add(2, "hours");
    }

    return {newStartDate, newEndDate}
}

export const checkResObjectDates = (startDate: moment.Moment | null, endDate:  moment.Moment | null,
                                    resObjectStart: string, resObjectEnd: string, resStartTime: string, resEndTime: string) => {
    // this function is the very last check of start and end dates + times when creating a res
    // reservation data is compared to search parameter data which is the original data used to set res data,
    // if something went wrong in session and res object does not have correct data, this will correct the date times
    let correctStartTime = moment(startDate).format('HH:mm');
    let correctEndTime = moment(endDate).format('HH:mm');

    if (resStartTime !== correctStartTime || resEndTime !== correctEndTime ||
        resObjectStart !== moment(startDate).format('DD.MM.YYYY') ||
        resObjectEnd !== moment(endDate).format('DD.MM.YYYY')) {
        return {startDate: moment(startDate).format('DD.MM.YYYY'),
            endDate: moment(endDate).format('DD.MM.YYYY'),
            startTime: correctStartTime, endTime: correctEndTime} ;
    }
    return undefined;
}